<template>
  <div>
    <common-dialog ref="dialog" width="1400px" :title="data.batch ? '批量报工' : '报工'" id-key="ReportId" :data="data" @closed="onClosed" @edit-opened="openEditOpened" :showSaveButton="false">
      <!-- :get-data-func="api.info" -->
      <template slot="form">
        <div class="row-tb-head">
          <div class="flex">
            <div class="mrx36 flex">
              <div style="min-width: 60px">工单编码</div>
              <el-input v-model="workNo" placeholder="输入工单编码" @change="chooseSets"></el-input>
            </div>
            <span style="margin-right: 80px">可以扫码或者输入后自动回车显示到下面表格</span>
            <div class="mrx36">
              <span class="inline_block">制单人：</span>
              <span class="inline_block">{{ data.Dts.length > 0 ? operator : '' }}</span>
            </div>
          </div>
        </div>
        <el-table class="table-line tb-c-head" :data="data.Dts" border v-if="displayMode === 1">
          <el-table-column label="订单编号" prop="OrderNo" min-width="170" show-overflow-tooltip />
          <el-table-column label="工单编号" prop="WorkDocNo" min-width="170" show-overflow-tooltip />
          <el-table-column label="模具编号" prop="MouldNo" min-width="120" show-overflow-tooltip />
          <el-table-column label="模具名称" prop="MouldName" min-width="120" />
          <el-table-column label="模数" prop="Quantity" min-width="70" />
          <el-table-column label="排产模数" prop="ThisPlanQuantity" width="80" />
          <el-table-column label="一出几" prop="Afew" width="80" />
          <el-table-column label="已报工数" prop="ThisReportQuantity" width="90" />
          <el-table-column label="完成率(%)" prop="CompletionRate" width="100" />
          <el-table-column label="工序方案" prop="ProgrammeName" width="100" />
          <el-table-column label="工序顺序" prop="ProcessSn" width="100" />
          <el-table-column label="工序名称" prop="ProcessName" width="100" />
          <el-table-column label="本次模数" prop="ThisReportQuantityNumber" width="100" fixed="right">
            <template slot-scope="{ row }">
              <el-input v-model="row.ThisReportQuantityNumber" placeholder="请输入本次模数"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="本次克重" prop="Grammage" width="100" fixed="right">
            <template slot-scope="{ row }">
              <el-input v-model="row.Grammage" placeholder="请输入本次克重" @change="changeMouldGrammage($event, row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="本次报工数(kg)" prop="ThisReportQuantityNumber2" width="110" fixed="right">
            <template slot-scope="{ row }">
              <el-input v-model="row.ThisReportQuantityNumber2" @change="changeMouldNumber2($event, row)" placeholder="请输入本次报工数(kg)"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="本次报工员工" prop="EmpId" width="150" fixed="right">
            <template slot-scope="{ row }">
              <select-input placeholder="选择人员" :label="row.EmpName" v-model="row.EmpId" @click="openEmpDialog(row)" />
            </template>
          </el-table-column>
        </el-table>
        <el-table class="table-line tb-c-head" :data="data.Dts" border v-if="displayMode === 2">
          <el-table-column label="订单编号" prop="OrderNo" min-width="170" show-overflow-tooltip />
          <el-table-column label="工单编号" prop="WorkDocNo" min-width="170" show-overflow-tooltip />
          <el-table-column label="存货编号" prop="ProductNo" min-width="120" show-overflow-tooltip />
          <el-table-column label="存货名称" prop="ProductName" min-width="120" />
          <el-table-column label="生产数量" prop="Quantity" min-width="70" />
          <el-table-column label="排产数量" prop="ThisPlanQuantity" width="80" />
          <el-table-column label="已报工数" prop="ThisReportQuantity" width="90" />
          <el-table-column label="完成率(%)" prop="CompletionRate" width="100" />
          <el-table-column label="工序方案" prop="ProgrammeName" width="100" />
          <el-table-column label="工序顺序" prop="ProcessSn" width="100" />
          <el-table-column label="工序名称" prop="ProcessName" width="100" />
          <el-table-column label="本次报工数" prop="ThisReportQuantityNumber" width="100" fixed="right">
            <template slot-scope="{ row }">
              <el-input v-model="row.ThisReportQuantityNumber" placeholder="请输入本次报工数"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="本次克重" prop="Grammage" width="100" fixed="right">
            <template slot-scope="{ row }">
              <el-input v-model="row.Grammage" placeholder="请输入本次克重" @change="changeProductGrammage($event, row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="本次报工数(kg)" prop="ThisReportQuantityNumber2" width="110" fixed="right">
            <template slot-scope="{ row }">
              <el-input v-model="row.ThisReportQuantityNumber2" @change="changeProductNumber2($event, row)" placeholder="请输入本次报工数(kg)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="本次报工员工" prop="EmpId" width="150" fixed="right">
            <template slot-scope="{ row }">
              <select-input placeholder="选择人员" :label="row.EmpName" v-model="row.EmpId" @click="openEmpDialog(row)" />
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
      <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import empDialog from '@/components/personnel/result/record/listDialog'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    empDialog
  },
  props: {
    displayMode: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      api: require('@/api/pu/report').default,
      // api: require("@/api/sy/user").default,
      workNo: '',
      data: {
        ReportId: 0,
        PlanId: null,
        Stage: 0,
        StartDate: null,
        EndDate: null,
        ProcessName: '',
        ReportDate: null,
        Dts: [],
        Materials: [],
        Products: [],
        operator: '',
        batch: false
        // workInfo: []
      },
      selectData: {}
    }
  },
  computed: {},
  methods: {
    changeMouldGrammage(val, row) {
      if (val) {
        if (row.ThisReportQuantityNumber2) {
          var quantity = (row.ThisReportQuantityNumber2 * 1000) / val
          row.ThisReportQuantityNumber = parseInt(quantity / row.Afew)
        }
      }
    },
    changeMouldNumber2(val, row) {
      if (val) {
        if (row.Grammage) {
          var quantity = (val * 1000) / row.Grammage
          row.ThisReportQuantityNumber = parseInt(quantity / row.Afew)
        }
      }
    },
    changeProductGrammage(val, row) {
      if (val) {
        if (row.ThisReportQuantityNumber2) {
          row.ThisReportQuantityNumber = parseInt((row.ThisReportQuantityNumber2 * 1000) / val)
          console.log(row, 'changeProductGrammage')
        }
      }
    },
    changeProductNumber2(val, row) {
      if (val) {
        if (row.Grammage) {
          var quantity = (Number(val) * 1000) / Number(row.Grammage)
          row.ThisReportQuantityNumber = parseInt(quantity)
          console.log(row, 'changeProductNumber2')
        }
      }
    },
    openEmpDialog(row) {
      this.selectData = row
      console.log(row, 'en')
      this.$refs.empDialog.open().then(that => {
        that.getData()
      })
    },

    setEmp(emp) {
      console.log(emp)
      var selectData = this.selectData
      // var tableData=this.data.Dts.find(x=>x.ReportId==selectData.ReportId);
      // tableData.EmpId = emp.EmpId
      // tableData.EmpName = emp.EmpName
      this.data.Dts.forEach(item => {
        if (item.WorkDocId == selectData.WorkDocId) {
          item.EmpId = emp.EmpId
          item.EmpName = emp.EmpName
        }
      })
    },
    chooseSets(data) {
      this.api
        .getWorkDocProductReportList({
          WorkDocNo: data
        })
        .then(res => {
          this.data.Dts = []
          if (res.Data && res.Data.length > 0) {
            res.Data.forEach(item => {
              console.log('item', item)
              //item.ThisReportQuantityNumber = this.displayMode === 1 ? '' : item.ThisPlanQuantity - item.ThisReportQuantity
              item.ThisReportQuantityNumber = null
              item.ThisReportQuantityNumber2 = null
              item.Grammage = null
              this.data.Dts.push(item)
            })
          } else {
            this.$message.warning('暂无数据！')
          }
        })
        .catch(err => {
          this.$message.error(err)
          console.log(err)
        })
      // if (data != '') {
      //   this.data.Dts = this.workInfo.filter(obj => {
      //     const isFilter = data.split('').some((item, index) => {
      //       return  obj.WorkDocNo.split('')[index] !== item
      //     })
      //     return !isFilter
      //   })
      // } else {
      //   this.data.Dts = this.workInfo;
      // }
    },
    onClosed() {
      this.data.Dts = []
      this.data.Materials = []
      this.data.Products = []
      this.workNo = ''
    },
    async openEditOpened(data) {
      console.log(data, 'reportData')
      this.operator = JSON.parse(localStorage.getItem('loginInfo')).UserName
      // this.data.Dts = data.infoData;
      // // this.workInfo = data.infoData;
      // this.data.batch = data.batch;
      let o = {}
      let infoData = []
      if (data.batch) {
        const ids = data.checkList.map(item => item.WorkDocId)
        o = { WorkDocIds: ids }
      } else {
        o = {
          WorkDocId: data.row.WorkDocId,
          WorkDocNo: data.row.WorkDocNo,
          PlanDtsId:data.row.PlanDtsId
        }
      }
      const res = await this.api.getWorkDocProductReportList(o)
      if (!res.IsSucc) return this.$message.error(res.Msg)
      if (res.Data && res.Data.length > 0) {
        infoData = res.Data
      }
      // this.edit({infoData: this.$refs.toCheckList.workInfo, batch: true})
      this.data.Dts = infoData.map(item => {
        return {
          ...item,
          ThisReportQuantityNumber: null,
          ThisReportQuantityNumber2: null,
          Grammage: null,
          PlanDtsId:data.row.PlanDtsId,
          PlanId:data.row.PlanId
          //ThisReportQuantityNumber: this.displayMode === 1 ? '' : item.ThisPlanQuantity - item.ThisReportQuantity
        }
      })
      this.data.batch = data.batch
    },
    async onSubmit() {
      let isReturn = false
      const arr = this.data.Dts.map(item => {
        if (item.ThisReportQuantityNumber == null || item.ThisReportQuantityNumber == undefined) {
          this.$message.error('请输入本次报工数')
          isReturn = true
        }

        if (item.ThisReportQuantityNumber2 == null || item.ThisReportQuantityNumber2 == undefined) {
          this.$message.error('请输入本次报工数（kg）')
          isReturn = true
        }

        if (item.Grammage == null || item.Grammage == undefined) {
          this.$message.error('请输入本次克重')
          isReturn = true
        }

        if (item.EmpId == null || item.EmpId == undefined) {
          this.$message.error('请选择本次报工员工')
          isReturn = true
        }
        return {
          WorkDocId: item.WorkDocId,
          ThisReportQuantity: Number(item.ThisReportQuantityNumber),
          ThisReportQuantity2: Number(item.ThisReportQuantityNumber2),
          Grammage: Number(item.Grammage),
          WorkDocProcessId: item.WorkDocProcessId,
          EmpId: item.EmpId,
          PlanId:item.PlanId,
          PlanDtsId:item.PlanDtsId
        }
      })
      if (isReturn) return
      const res = await this.api.submit({ ReportSaves: arr })
      if (!res.IsSucc) return this.$message.error(res.Msg)
      this.$message.success('保存成功！')
      this.$refs.dialog.isChange = false
      this.close()
      this.$emit('saved')
    },
    close() {
      this.$refs.dialog.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
.inline_block {
  display: inline-block;
}
.mrx36 {
  margin-right: 36px;
}
</style>